import _ from 'lodash';
import { Validators } from '@angular/forms';

import { CampaignSchema } from './campaign';
import { AMOUNT_LIMIT } from 'app/virtual-event/virtual-event.enums';


// 0 "name"
// 1  "imageUrl"
// 2  "additionalImages"
// 3  "count"
// 4  "minBid"
// 5  "bidIncrement"
// 6  "valueProvided"
// 7  "buyItNowOnlyItem"
// 8  "buyItNowEnabled"
// 9  "buyItNowAmount"
// 10  "collectSalesTax"
// 11  "salesTax"
// 12  "categories"
// 13  "desc"
// 14  "memo"
// 15  "featured"
// 16  "donatedByName"
// 17  "displayDonatedBy"
// 18  "itemCode"
// 19  "displayToDonors"
// 20  "addVideo"
// 21  "videoProvider"
// 22  "videoUrl"
// 23  "currentBid"
// 24  "soldCount"
// 25  "additionalInfoRequired"
// 26  "additionalInfoDesc"
// 27  "additionalInfo"
// 28  "additionalInfoSelectRequired"
// 29  "additionalInfoSelectDesc"
// 30  "additionalInfoSelect"

export const SilentAuctionPresetOptionSchema = {
    'fields': [{
        'field': 'additionalImageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'additionalImageDataUrls',
        'value': [],
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const list = _.isString(data.additionalImages) ? _.split(data.additionalImages, ','): data.additionalImages;
                return _.isEmpty(list) ? []: _.map(list, (element) => _.trim(element));
            }
        }
    }, {
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'position',
        'value': 0,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'amount',
        'value': 0,
        'validators': [Validators.required, Validators.min(0), Validators.max(400000)],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'name',
        'type': 'string',
        'value': '',
        'column': 0,
        'validators': [Validators.required, Validators.maxLength(128)]
    }, {
        'field': 'imageUrl',
        'type': 'string',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value;
            }
        }
    }, {
        'field': 'vImageUrl',
        'type': 'string',
        'value': '/images/blank_2x1.png',
        'column': 1,
        'validators': [],
        'options': {
            'virtual': false,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'additionalImages',
        'type': 'array',
        'value': [],
        'validators': [],
        'options': {
            'setter': (data, value) => {
                const list = _.isString(value) ? _.split(value, ','): value;
                return _.isEmpty(list) ? []: _.map(list, (element) => _.trim(element));
            }
        }
    }, {
        'field': 'vAdditionalImages',
        'type': 'array',
        'value': [],
        'column': 2,
        'validators': [],
        'options': {
            'virtual': false,
            'setter': (data, value) => {
                const list = _.isString(value) ? _.split(value, ','): value;
                return _.isEmpty(list) ? []: _.map(list, (element) => _.trim(element));
            }
        }
    }, {
        'field': 'thumbnailUrl',
        'type': 'string',
        'value': '/images/blank_1x1.png',
        'column': 3,
        'validators': [],
        'options': {
            'virtual': false,
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_1x1.png': value
            }
        }
    }, {
        'field': 'count',
        'type': 'number',
        'value': 0,
        'column': 4,
        'validators': [Validators.required, Validators.min(1), Validators.max(10000)],
        'options': {
            'getter': (control) => parseInt(control.value) || 0,
            'setter': (data, value) => parseInt(value) || 0
        }
    }, {
        'field': 'minBid',
        'type': 'number',
        'value': 0,
        'column': 5,
        'validators': [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0,
            'validators': (data, value) => {
                const buyItNowOnlyItem = _.get(data, 'buyItNowOnlyItem', false);
                return buyItNowOnlyItem ? []: [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)];
            }
        }
    }, {
        'field': 'bidIncrement',
        'type': 'number',
        'value': 0,
        'column': 6,
        'validators': [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0,
            'validators': (data, value) => {
                const buyItNowOnlyItem = _.get(data, 'buyItNowOnlyItem', false);
                return buyItNowOnlyItem ? []: [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)];
            }
        }
    }, {
        'field': 'valueProvided',
        'type': 'number',
        'value': 0,
        'column': 7,
        'validators': [Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => {
                return control.value;
            }
        }
    }, {
        'field': 'buyItNowOnlyItem',
        'type': 'boolean',
        'value': false,
        'column': 8,
        'validators': []
    }, {
        'field': 'buyItNowEnabled',
        'type': 'boolean',
        'value': false,
        'column': 9,
        'validators': [],
        'options': {
            'validators': (data, value) => {
                return data.buyItNowOnlyItem ? [Validators.requiredTrue]: [];
            }
        }
    }, {
        'field': 'buyItNowAmount',
        'type': 'number',
        'value': 0,
        'column': 10,
        'validators': [Validators.required],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0,
            'validators': (data, value) => {
                return data.buyItNowEnabled ? [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)]: [];
            }
        }
    }, {
        'field': 'collectSalesTax',
        'type': 'boolean',
        'value': false,
        'column': 11,
        'validators': []
    }, {
        'field': 'salesTax',
        'type': 'number',
        'value': 0,
        'column': 12,
        'validators': [],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0,
            'validators': (data, value) => {
                return data.collectSalesTax ? [Validators.required, Validators.min(0.01), Validators.max(100)]: [];
            }
        }
    }, {
        'field': 'categories',
        'type': 'array',
        'value': [],
        'column': 13,
        'validators': [],
        'options': {
            'setter': (data, categories) => {
                if(categories) {
                    return categories.map(category => {
                        return category.trim();
                    }).filter(category => {
                        return category !== '';
                    })
                }
            },
        }
    }, {
        'field': 'desc',
        'type': 'string',
        'value': '',
        'column': 14, 
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'summary',
        'type': 'string',
        'value': '',
        'column': 15,
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'memo',
        'type': 'string',
        'value': '',
        'column': 16, 
        'validators': [],
        'options': {
            'setter': (data, value) => value.substring(0, 2048)
        }
    }, {
        'field': 'currentBid',
        'value': 0,
        'validators': []
    }, {
        'field': 'currentBids',
        'value': [],
        'validators': []
    }, {
        'field': 'soldCount',
        'value': 0,
        'validators': []
    }, {
        'field': 'status',
        'value': 0,
        'validators': []
    }, {
        'field': 'featured',
        'column': 17,
        'type': 'boolean',
        'value': false,
        'validators': []
    }, {
        'field': 'donatedByName',
        'type': 'string',
        'value': '',
        'column': 18,
        'options': {
          'getter': (control) => control.value || '',
          'setter': (data, value) => value || '',
          'validators': (data, value) => {
            return data.displayDonatedBy ? [Validators.maxLength(64)] : [];
          }
        }
      }, {
        'field': 'displayDonatedBy',
        'type': 'boolean',
        'column': 19,
        'value': false,
        'validators': []
      },{
      'field': 'itemCode',
      'type': 'string',
      'column': 20,
      'value': '',
      'validators': [Validators.maxLength(32)]
    }, {
      'field': 'displayToDonors',
      'column': 21,
      'type': 'boolean',
      'value': false,
      'validators': []
    }, {
      'field': 'addVideo',
      'column': 22,
      'type': 'boolean',
      'value': false,
      'validators': []
    }, {
      'field': 'videoProvider',
      'column': 23,
      'type': 'number',
      'value': 0,
      'validators': [],
    }, {
      'field': 'videoUrl',
      'column': 24,
      'type': 'string',
      'value': '',
      'validators': [],
    }, {
        'field': 'additionalInfoRequired',
        'type': 'boolean',
        'value': false,
        'column': 25,
        'validators': [],
        'options': {
            'setter': (data, value) => {
                if(value === true) {
                    return true;
                }
                return _.isEmpty(data.additionalInfoDesc) ? false: true
            }
        }
    }, {
        'field': 'additionalInfoDesc',
        'value': '',
        'column': 26,
        'validators': [],
        'options': {
          'setter': (data, value) => value || '',
          'validators': (data) => {
              return data.additionalInfoRequired ? [Validators.required] : [];
          }
        }
    }, {
        'field': 'additionalInfoDetail',
        'value': '',
        'column': 27,
        'validators': [],
        'options': {
            'setter': (data, value) => value || '',
        }
    }, {
      'field': 'additionalInfoSelectRequired',
      'type': 'boolean',
      'value': false,
        'column': 28,
        'validators': [],
        'options': {
            'setter': (data, value) => {
                if(value === true) {
                    return true;
                }
                return _.isEmpty(data.additionalInfoSelectDesc) ? false: true
            }
        }
    }, {
        'field': 'additionalInfoSelectDesc',
        'value': '',
        'column': 29,
        'validators': [],
        'options': {
            'validators': (data, value) => {
                return data.additionalInfoSelectRequired ? [Validators.required]: [];
            }
        }
    }, {
        'field': 'additionalInfoSelect',
        'type': 'array',
        'value': [],
        'column': 30,
        'validators': [],
        'options': {
            'setter': (data, tags) => {
                if(tags) {
                    return tags.map(tag => {
                        return tag.trim();
                    }).filter(tag => tag !== '');
                }
            },
            'validators': (data, value) => {
                return data.additionalInfoSelectRequired ? [Validators.required]: [];
            }
        }
    }]
};

export const LiveAuctionPresetOptionSchema = {
    'fields': [{
        'field': 'additionalImageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'additionalImageDataUrls',
        'value': [],
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const list = _.isString(data.additionalImages) ? _.split(data.additionalImages, ','): data.additionalImages;
                return _.isEmpty(list) ? []: _.map(list, (element) => _.trim(element));
            }
        }
    }, {
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'additionalImages',
        'type': 'array',
        'value': [],
        'validators': [],
        'options': {
            'setter': (data, value) => {
                const list = _.isString(value) ? _.split(value, ','): value;
                return _.isEmpty(list) ? []: _.map(list, (element) => _.trim(element));
            }
        }
    }, {
      'field': 'imageUrl',
      'type': 'string',
      'value': '/images/blank_2x1.png',
      'validators': [],
      'options': {
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '': control.value
        },
        'setter': (data, value) => {
          try {
            const imageUrl = new URL(data.vImageUrl);
            return imageUrl.href;
          } catch(e) {
            return value === '' ? '/images/blank_2x1.png': value;
          }
        }
      }
    }, {
      'field': 'position',
      'value': 0,
      'validators': [],
      'options': {
        'virtual': true
      }
    }, {
      'field': 'amount',
      'value': 0,
      'validators': [Validators.required, Validators.min(0), Validators.max(400000)],
      'options': {
        'getter': (control) => parseInt(control.value) || 0,
        'setter': (data, value) => parseInt(value) || 0
      }
    }, {
        'field': 'status',
        'value': 0,
        'validators': []
    }, {
        'field': 'currentBids',
        'value': [],
        'validators': []
    }, {
        'field': 'currentBid',
        'value': 0,
        'validators': []
    }, {
        'field': 'soldCount',
        'value': 0,
        'validators': []
    }, {
      'field': 'name',
      'type': 'string',
      'value': '',
      'column': 0,
      'validators': [Validators.required, Validators.maxLength(128)]
    }, {
      'field': 'vImageUrl',
      'type': 'string',
      'value': '/images/blank_2x1.png',
      'column': 1,
      'validators': [],
      'options': {
        'virtual': false,
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '': control.value
        },
        'setter': (data, value) => {
          return value === '' ? '/images/blank_2x1.png': value
        }
      }
    }, {
        'field': 'vAdditionalImages',
        'type': 'array',
        'value': [],
        'column': 2,
        'validators': [],
        'options': {
            'virtual': false,
            'setter': (data, value) => {
                const list = _.isString(value) ? _.split(value, ','): value;
                return _.isEmpty(list) ? []: _.map(list, (element) => _.trim(element));
            }
        }
    }, {
        'field': 'thumbnailUrl',
        'type': 'string',
        'value': '/images/blank_1x1.png',
        'column': 3,
        'validators': [],
        'options': {
            'virtual': false,
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_1x1.png': value
            }
        }
    },  {
      'field': 'count',
      'type': 'number',
      'value': 0,
      'column': 4,
      'validators': [Validators.required, Validators.min(1), Validators.max(10000)],
      'options': {
        'getter': (control) => parseInt(control.value) || 0,
        'setter': (data, value) => parseInt(value) || 0
      }
    }, {
      'field': 'minBid',
      'type': 'number',
      'value': 0,
      'column': 5,
      'validators': [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
      'options': {
        'getter': (control) => parseFloat(control.value) || 0,
        'setter': (data, value) => parseFloat(value) || 0,
        'validators': (data, value) => {
          const buyItNowOnlyItem = _.get(data, 'buyItNowOnlyItem', false);
          return buyItNowOnlyItem ? []: [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)];
        }
      }
    }, {
        'field': 'bidIncrement',
        'type': 'number',
        'value': 0,
        'column': 6,
        'validators': [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0,
            'validators': (data, value) => {
                const buyItNowOnlyItem = _.get(data, 'buyItNowOnlyItem', false);
                return buyItNowOnlyItem ? []: [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)];
            }
        }
    }, {
        'field': 'valueProvided',
        'type': 'number',
        'value': 0,
        'column': 7,
        'validators': [Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => {
                return control.value;
            }
        }
    }, {
      'field': 'collectSalesTax',
      'type': 'boolean',
      'value': false,
      'column': 8,
      'validators': []
    }, {
      'field': 'salesTax',
      'type': 'number',
      'value': 0,
      'column': 9,
      'validators': [],
      'options': {
        'getter': (control) => parseFloat(control.value) || 0,
        'setter': (data, value) => parseFloat(value) || 0,
        'validators': (data, value) => {
          return data.collectSalesTax ? [Validators.required, Validators.min(0.01), Validators.max(100)]: [];
        }
      }
    }, {
      'field': 'categories',
      'type': 'array',
      'value': [],
      'column': 10,
      'validators': [],
      'options': {
        'setter': (data, categories) => {
          if(categories) {
            return categories.map(category => {
              return category.trim();
            }).filter(category => {
              return category !== '';
            })
          }
        },
      }
    }, {
      'field': 'desc',
      'type': 'string',
      'value': '',
      'column': 11,
      'validators': [],
      'options': {
        'getter': (control) => {
            const reg = new RegExp(String.fromCharCode(160), 'g');
            return control.value
                .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                .replaceAll(reg, ' ');
        }
    }
    }, {
        'field': 'summary',
        'type': 'string',
        'value': '',
        'column': 12,
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
      'field': 'memo',
      'type': 'string',
      'value': '',
      'column': 13,
      'validators': [],
      'options': {
        'setter': (data, value) => value.substring(0, 2048)
      }
    }, {
      'field': 'featured',
      'column': 14,
      'type': 'boolean',
      'value': false,
      'validators': []
    }, {
      'field': 'donatedByName',
      'type': 'string',
      'value': '',
      'column': 15,
      'options': {
        'getter': (control) => control.value || '',
        'setter': (data, value) => value || '',
        'validators': (data, value) => {
          return data.displayDonatedBy ? [Validators.maxLength(64)] : [];
        }
      }
    }, {
      'field': 'displayDonatedBy',
      'column': 16,
      'type': 'boolean',
      'value': false,
      'validators': []
    }, {
      'field': 'itemCode',
      'type': 'string',
      'column': 17,
      'value': '',
      'validators': [Validators.maxLength(32)]
    }, {
      'field': 'displayToDonors',
      'column': 18,
      'type': 'boolean',
      'value': false,
      'validators': []
    },  {
      'field': 'addVideo',
      'column': 19,
      'type': 'boolean',
      'value': false,
      'validators': []
    }, {
      'field': 'videoProvider',
      'column': 20,
      'type': 'number',
      'value': 0,
      'validators': [],
    }, {
      'field': 'videoUrl',
      'column': 21,
      'type': 'string',
      'value': '',
      'validators': [],
    }, {
        'field': 'additionalInfoRequired',
        'type': 'boolean',
        'value': false,
        'column': 22,
        'validators': [],
        'options': {
            'setter': (data, value) => {
                if(value === true) {
                    return true;
                }
                return _.isEmpty(data.additionalInfoDesc) ? false: true
            }
        }
    }, {
        'field': 'additionalInfoDesc',
        'value': '',
        'column': 23,
        'validators': [],
        'options': {
          'setter': (data, value) => value || '',
          'validators': (data) => {
              return data.additionalInfoRequired ? [Validators.required] : [];
          }
        }
    }, {
        'field': 'additionalInfoDetail',
        'value': '',
        'column': 24,
        'validators': [],
        'options': {
            'setter': (data, value) => value || '',
        }
    }, {
      'field': 'additionalInfoSelectRequired',
      'type': 'boolean',
      'value': false,
      'column': 25,
      'validators': [],
      'options': {
        'setter': (data, value) => {
            if(value === true) {
                return true;
            }
            return _.isEmpty(data.additionalInfoSelectDesc) ? false: true
        }
    }
    }, {
        'field': 'additionalInfoSelectDesc',
        'value': '',
        'column': 26,
        'validators': [],
          'options': {
              'validators': (data, value) => {
                  return data.additionalInfoSelectRequired ? [Validators.required]: [];
              }
          }
    }, {
        'field': 'additionalInfoSelect',
        'type': 'array',
        'value': [],
        'column': 27,
        'validators': [],
        'options': {
            'setter': (data, tags) => {
                if(tags) {
                    return tags.map(tag => {
                        return tag.trim();
                    }).filter(tag => tag !== '');
                }
            },
            'validators': (data, value) => {
                return data.additionalInfoSelectRequired ? [Validators.required]: [];
            }
        }
    }]
};

export const AuctionPresetOptionSchema = {
    'fields': [{
        'field': 'additionalImageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'additionalImageDataUrls',
        'value': [],
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                const list = _.isString(data.additionalImages) ? _.split(data.additionalImages, ','): data.additionalImages;
                return _.isEmpty(list) ? []: list;
            }
        }
    }, {
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'imageUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'thumbnailFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'thumbnailDataUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.thumbnailUrl === '' ? '/images/blank_1x1.png': data.thumbnailUrl
            }
        }
    }, {
        'field': 'thumbnailUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_1x1.png': value
            }
        }
    }, {
        'field': 'position',
        'value': 0,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'id',
        'value': null,
        'validators': [],
    }, {
        'field': 'additionalImages',
        'type': 'array',
        'value': [],
        'validators': [],
        'options': {
            'setter': (data, value) => {
                const list = _.isString(value) ? _.split(value, ','): value;
                return _.isEmpty(list) ? []: list;
            }
        }
    }, {
        'field': 'amount',
        'value': 0,
        'validators': [Validators.required, Validators.min(0), Validators.max(400000)],
        'options': {
            'getter': (control) => {
                return parseInt(control.value) || 0;
            },
            'setter': (data, value) => parseInt(value) || 0
        }
    }, {
        'field': 'bidIncrement',
        'type': '',
        'value': 0,
        'validators': [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0,
            'validators': (data, value) => {
                const buyItNowOnlyItem = _.get(data, 'buyItNowOnlyItem', false);
                const validators = buyItNowOnlyItem ? []: [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)];
                return validators;
            }
        }
    }, {
        'field': 'categories',
        'value': [],
        'validators': [],
        'options': {
            'setter': (data, categories) => {
                if(categories) {
                    return categories.map(category => {
                        return category.trim();
                    }).filter(category => {
                        return category !== '';
                    })
                }
            },
        }
    }, {
        'field': 'count',
        'value': 1,
        'validators': [Validators.required, Validators.min(1), Validators.max(10000)],
        'options': {
            'getter': (control) => parseInt(control.value) || 1,
            'setter': (data, value) => parseInt(value) || 1
        }
    }, {
        'field': 'desc',
        'type': 'string',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'summary',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'memo',
        'type': 'string',
        'value': '',
        'validators': [],
        'options': {
            'setter': (data, value) => value.substring(0, 2048)
        }
    }, {
        'field': 'minBid',
        'type': 'number',
        'value': 0,
        'validators': [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0,
            'validators': (data, value) => {
                const buyItNowOnlyItem = _.get(data, 'buyItNowOnlyItem', false);
                return buyItNowOnlyItem ? []: [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)];
            }
        }
    }, {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(512)]
    }, {
        'field': 'valueProvided',
        'type': 'number',
        'value': 0,
        'validators': [Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)],
        'options': {
            'getter': (control) => {
                return control.value;
            }
        }
    }, {
        'field': 'buyItNowOnlyItem',
        'value': false,
        'validators': []
    }, {
        'field': 'buyItNowEnabled',
        'type': 'boolean',
        'value': false,
        'validators': [],
        'options': {
            'validators': (data, value) => {
                return data.buyItNowOnlyItem ? [Validators.requiredTrue]: [];
            }
        }
    }, {
        'field': 'buyItNowAmount',
        'value': 0,
        'validators': [Validators.required],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0,
            'validators': (data, value) => {
                return data.buyItNowEnabled ? [Validators.required, Validators.min(1), Validators.max(AMOUNT_LIMIT.GLOBAL_MAX)] : [];
            }
        }
    }, {
        'field': 'collectSalesTax',
        'type': 'boolean',
        'value': false,
        'validators': []
    }, {
        'field': 'salesTax',
        'type': 'number',
        'value': 0,
        'validators': [],
        'options': {
            'getter': (control) => parseFloat(control.value) || 0,
            'setter': (data, value) => parseFloat(value) || 0,
            'validators': (data, value) => {
                return data.collectSalesTax ? [Validators.required, Validators.min(0.01), Validators.max(100)]: [];
            }
        }
    }, {
      'field': 'displayDonatedBy',
      'type': 'boolean',
      'value': false,
      'column': 17,
      'validators': []
    }, {
      'field': 'donatedByName',
      'type': 'string',
      'value': '',
      'column': 16,
      'options': {
        'getter': (control) => control.value || '',
        'setter': (data, value) => value || '',
        'validators': (data, value) => {
          return data.displayDonatedBy ? [Validators.maxLength(64)] : [];
        }
      }
    }, {
        'field': 'currentBid',
        'column': 23,
        'value': 0,
        'validators': []
    }, {
        'field': 'currentBids',
        'value': [],
        'validators': []
    }, {
        'field': 'soldCount',
        'column': 24,
        'value': 0,
        'validators': []
    }, {
        'field': 'status',
        'value': 0,
        'validators': []
    }, {
      'field': 'itemCode',
      'type': 'string',
      'column': 18,
      'value': '',
      'validators': [Validators.maxLength(32)]
    }, {
      'field': 'displayToDonors',
      'column': 19,
      'type': 'boolean',
      'value': false,
      'validators': []
    }, {
      'field': 'featured',
      'column': 15,
      'type': 'boolean',
      'value': false,
      'validators': []
    }, {
      'field': 'addVideo',
      'column': 20,
      'type': 'boolean',
      'value': false,
      'validators': []
    }, {
      'field': 'videoProvider',
      'column': 21,
      'type': 'number',
      'value': 0,
      'validators': [],
    }, {
      'field': 'videoUrl',
      'column': 22,
      'type': 'string',
      'value': '',
      'validators': [],
    }, {
      'field': 'additionalInfoRequired',
      'type': 'boolean',
      'value': false,
      'validators': [],
      'options': {
            'setter': (data, value) => {
                if(value === true) {
                    return true;
                }
                return _.isEmpty(data.additionalInfoDesc) ? false: true
            }
      }
    }, {
      'field': 'additionalInfoDetail',
      'value': '',
      'validators': [],
      'options': {
        'setter': (data, value) => value || ''
      }
    }, {
      'field': 'additionalInfoDesc',
      'value': '',
      'validators': [],
      'options': {
        'setter': (data, value) => value || '',
        'validators': (data) => {
            return data.additionalInfoRequired ? [Validators.required] : [];
        }
      }
    }, {
      'field': 'additionalInfoSelectRequired',
      'type': 'boolean',
      'value': false,
      'validators': [],
      'options': {
            'setter': (data, value) => {
                if(value === true) {
                    return true;
                }
                return _.isEmpty(data.additionalInfoSelectDesc) ? false: true
            }
      }
    }, {
      'field': 'additionalInfoSelect',
      'value': [],
      'validators': [],
      'options': {
        'setter': (data, value) => value || [],
        'validators': (data) => {
            return data.additionalInfoSelectRequired ? [Validators.required] : [];
        }
      }
    }, {
      'field': 'additionalInfoSelectDesc',
      'value': '',
      'validators': [],
      'options': {
        'validators': (data) => {
            return data.additionalInfoSelectRequired ? [Validators.required] : [];
        }
      }
    },  {
        'field': 'optionStartDate',
        'type': 'datetime',
        'value': 0,
        'column': 13,
        'validators': [Validators.required, Validators.nullValidator]
    }, {
        'field': 'optionEndDate',
        'type': 'datetime',
        'value': 0,
        'column': 14,
        'validators': [Validators.required, Validators.nullValidator]
    }]
};

const clonedCampaignSchema = _.cloneDeep(CampaignSchema);
clonedCampaignSchema.fields.push({
    'field': 'type',
    'value': 4,
    'validators': [Validators.required]
});

clonedCampaignSchema.groups = [{
    'group': 'campaignTypeData',
    'arrays': [{
        'array': 'presetOptions',
        'schema': AuctionPresetOptionSchema,
        'value': [],
        'validators': []
    }],
    'fields': [{
        'field': 'auctionWinnerInstruct',
        'value': '',
        'validators': []
    }, {
        'field': 'auctionType',
        'value': 0,
        'validators': []
    }, {
        'field': 'auctionStatus',
        'value': 0,
        'validators': []
    }, {
        'field': 'auctionControlMethod',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value ? 1: 0;
            },
            'setter': (data, value) => (value === 1) ? true: false
        }
    }, {
        'field': 'auctionStartTime',
        'value': () => null,
        'validators': [],
        'options': {
            'validators': (data, value) => {
                const auctionControlMethod = _.get(data, 'auctionControlMethod', 0);
                if(auctionControlMethod === 1) {
                    return [Validators.required, Validators.min(1)];
                }
                return [];
            }
        }
    }, {
        'field': 'auctionEndTime',
        'value': () => null,
        'validators': [],
        'options': {
            'validators': (data, value) => {
                const auctionControlMethod = _.get(data, 'auctionControlMethod', 0);
                if(auctionControlMethod === 1) {
                    return [];
                }
                return [];
            }
        }
    }, {
        'field': 'autoCloseEnabled',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value ? true: false;
            },
            'setter': (data, value) => (value === true) ? true: false
        }
    }, {
        'field': 'auctionCloseTime',
        'value': null,
        'validators': [],
        'options': {
            'validators': (data, value) => {
                const auctionClosingControlMethod = _.get(data, 'auctionClosingControlMethod', 0);
                if(auctionClosingControlMethod === 1) {
                    return [Validators.required, Validators.min(1)];
                }
                return [];
            },
        }
    }, {
        'field': 'hideTopBidder',
        'value': false,
        'validators': []
    }, {
        'field': 'showBidHistory',
        'value': false,
        'validators': []
    }, {
        'field': 'autoBidDisabled',
        'value': false,
        'validators': []
    }, {
      'field': 'showBestValueItems',
      'value': false,
      'validators': []
    }, {
      'field': 'showTrendingItems',
      'value': false,
      'validators': []
    },
    {
        'field': 'showItemValue',
        'value': false,
        'validators': []
    },
    {
        'field': 'verifyEmailForBidding',
        'value': false,
        'validators': []
    },
    {
        'field': 'saveCardRequired',
        'value': false,
        'validators': []
    }]
}];
export const AuctionSchema = clonedCampaignSchema;

